import React from 'react'
import { Grid } from '@mui/material'
import KpiTabView from './KpiTabView'

interface KpiSummaryProps {
  customKpiDetails: any
  alarmDetails?: any
}

const KpiSummary = ({ customKpiDetails, alarmDetails }: KpiSummaryProps): any => {
  return (
    <Grid data-testid='KpiSummary' sx={{ width: '100%', borderRadius: '10px', backgroundColor: '#272727', color: '#f0f0f0' }}>
      <KpiTabView alarmDetails={alarmDetails} viewKpiInfo={false} customKpiDetails={customKpiDetails}/>
    </Grid>
  )
}

export default KpiSummary
